import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { Box, Stack } from "@mui/material";

interface LoaderProps {
  type?: "tab" | "calendar" | "expandCalendar";
}

const DailyPOBTabCalendarLoader: React.FC<LoaderProps> = ({
  type = "tab",
}) => {
  return (
    <Stack direction="column" alignItems="center" gap={2}>
      {type === "tab" ? (
        <Skeleton variant="rectangular" width="100%" height={40} />
      ) : type === "calendar" ? (
        <Skeleton variant="rectangular" width="95%" height={200} />
      ) : type === "expandCalendar" ? (
        <>
          <Box display="flex" justifyContent="flex-start" width="100%">
            <Skeleton variant="rectangular" width="15%" height={30} />
          </Box>
          <Skeleton variant="rectangular" width="100%" height={250} />
          <Box display="flex" justifyContent="flex-start" width="100%">
            <Skeleton variant="rectangular" width="15%" height={30} />
          </Box>
          <Skeleton variant="rectangular" width="100%" height={250} />
          <Box display="flex" justifyContent="flex-start" width="100%">
            <Skeleton variant="rectangular" width="15%" height={30} />
          </Box>
          <Skeleton variant="rectangular" width="100%" height={250} />
        </>
      ) : (
        <Skeleton variant="text" width="80%" />
      )}
    </Stack>
  );
};

export default DailyPOBTabCalendarLoader;
